import React from "react";
import { References } from "fe-web-components/references/types";
import AnswerDialog from "./AnswerDialog";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Divider, Link, styled } from "@mui/material";
import { Reference } from "fe-web-components/references/Reference";
import { ReactComponent as OpenInNewIcon } from "fe-web-components/assets/openInNewIcon.svg";

const FootNoteData = styled("div")(({ theme }) => ({
  display: "inline-flex",
  gap: 4,
  padding: "10px 0",
  "& .paragraphLink": {
    color: theme.palette.primary.main,
  },
  "& svg": {
    width: 12,
    height: 12,
  },
}));

interface AnswerCitationInfoProps {
  text: string;
  citationIndex: number;
  footnoteIndex: number;
  references: References;
  onClose: () => void;
}

function AnswerCitationInfo({
  text,
  citationIndex,
  footnoteIndex,
  references,
  onClose,
}: AnswerCitationInfoProps) {
  const citation = references.citations?.[citationIndex];
  const footnote = references.footnotes?.[footnoteIndex];
  return (
    <AnswerDialog onClose={onClose}>
      <Markdown children={text} remarkPlugins={[remarkGfm]} />
      <Divider />
      {footnote?.clientData && (
        <>
          <FootNoteData>
            {footnote.clientData.paragraphid}
            <Link
              href={footnote.clientData.paragraphUrl}
              target="_blank"
              className={"paragraphLink"}
            >
              <OpenInNewIcon />
            </Link>
          </FootNoteData>
          <Divider />
        </>
      )}
      <Reference
        citationData={citation?.metadata}
        style={{ paddingTop: "1em" }}
      />
    </AnswerDialog>
  );
}

export default AnswerCitationInfo;
